
enum ProfessionalTypeKey {
	Consultant = "uri://m16s.io/professionaltype/consultant",
	TeamMember = "uri://m16s.io/professionaltype/teammember",
}

export type ProfessionalTypeKeyValue = `${ProfessionalTypeKey}`

export default ProfessionalTypeKey